export const installationKeys = {
  all: ["installation"] as const,
  installation: (installId: string | null) => [...installationKeys.all, installId] as const,
  orgCount: (installId: string | null) => [...installationKeys.all, installId, "orgCount"] as const,
  userCount: (installId: string | null) => [...installationKeys.all, installId, "userCount"] as const,
  projectCount: (installId: string | null) => [...installationKeys.all, installId, "projectCount"] as const,
  property: (installId: string | null, property: string) =>
    [...installationKeys.all, installId, "property", property] as const,
};
